import React, { Component } from 'react'
import './selectionitemcomplex.scss'
import Button from '../Button'
class SelectionItemComplex extends Component {
	constructor(props) {
		super(props)
		this.state = {
			info: props.info ? props.info : []
		}
	}

	render() {
		let classes = ['vbui--selectionitemcomplex', this.props.classes, this.props.state].join(' ')
		return (
			<div className={classes}>
				<div className="download-btn">
					<Button classes="ghost medium content-width" showIcon={true} icon="icon-icon-download"></Button>
				</div>
				<div className="img-carrier">
					<img src={this.props.imgURL} alt="" />
				</div>
				{this.state.info.map((line, i) => {
					return (
						<p key={i} className={line.className}>
							{line.text}
						</p>
					)
				})}
				<Button classes="fill medium" showIcon={true} icon="icon-icon-add-projects">
					Añadir al proyecto
				</Button>
				<Button classes="ghost medium" showIcon={true} icon="icon-icon-configure">
					Personalizar
				</Button>
			</div>
		)
	}
}

export default SelectionItemComplex
